import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import ItemView from "./ItemView";

export default class ExampleItemView extends ItemView {
    constructor(target) {
        super(target);
    }

    get target() {
        return this._target;
    }
    
    set content(skin) {
        CacheUtil.uncache(this._target);
        super.content = skin;
        this._addOutline();
        //cache total skin for performance
            const margin = ExampleItemView.CACHE_MARGIN;
        CacheUtil.cache(this._target, margin, margin);
    }

    _addOutline() {
        const bmp = this._content;
        if (bmp) {
            const radius = ExampleItemView.RADIUS;
            const steps = Math.round(radius * 3);
            const outline = this._target.addChildAt(new createjs.Container(), 0);
            for (let a = 0; a < Math.PI * 2; a += Math.PI * 2 / steps) {
                const dx = Math.cos(a) * radius;
                const dy = Math.sin(a) * radius;
                const clone = bmp.clone();
                outline.addChildAt(clone, 0);
                clone.x = bmp.x + dx;
                clone.y = bmp.y + dy;
            }
            outline.filters = [
                new createjs.ColorFilter(0, 0, 0, 1, 0x0F, 0x51, 0x84, 0)
            ];
            const margin = ExampleItemView.CACHE_MARGIN;
            //cache outline to apply filter
            CacheUtil.cache(outline, margin, margin);
        }
    }
}

ExampleItemView.RADIUS = 8;
ExampleItemView.CACHE_MARGIN = 10;